export enum CatalogState {
    INCOMPLETE = 'INCOMPLETE',
    COMPLETE = 'COMPLETE'
};